module.exports = __webpack_public_path__ + "img/suit-03.ecdc64cf.png";